import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import ResidencePage from './views/ResidencePage.vue';
import UrlBuilder from './views/UrlBuilder.vue';
import Comparison from './views/Comparison.vue';

Vue.use(Router);

//export default new Router({
const routes = [
  {
    path: '/',
    publicPath: '/',
    name: 'Boligvelger',
    component: Home,
  },
  {
    path: '/bolig/:slug',
    publicPath: '/',
    name: 'bolig',
    component: ResidencePage,
    meta: {
      scrollToTop: true,
    },
  },
  {
    path: '/urlbuilder/',
    publicPath: '/',
    name: 'URL Builder',
    component: UrlBuilder,
  },
  {
    path: '/comparison/',
    name: 'Comparison',
    component: Comparison,
  },
];

const router = new Router({
  routes,
  // TODO: Grave dypere i scrollBehavior
  /* scrollBehavior doesn't work as expected and has been removed for now */
  /*scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.name === 'Boligvelger' && from.name === 'bolig') {
      const element = `#${from.params.name}`;
      console.log(element); 
      return {
        selector: element,
        offset: {
          x: 0,
          y: 100,
        },
        behavior: 'smooth',
      };
    } else {
      return {
        selector: '#scrollHelper',
        offset: {
          x: 0,
          y: -10,
        },
        behavior: 'smooth',
      };
    }
  },*/
});

export default router;